var render, staticRenderFns
import script from "./LocalBackupsTable.vue?vue&type=script&lang=js&"
export * from "./LocalBackupsTable.vue?vue&type=script&lang=js&"
import style0 from "./LocalBackupsTable.vue?vue&type=style&index=0&id=aa3e4874&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa3e4874",
  null
  
)

export default component.exports